export namespace NotificationsActions {
  const prefix = '[Notifications]';

  export class getInitial {
    static readonly type = `${ prefix } Get initial notifications list`;
  }

  export class loadMore {
    static readonly type = `${ prefix } Load more notifications`;
  }

  export class remove {
    static readonly type = `${ prefix } Delete notification`;

    constructor(public notificationId: number) {
    }
  }

  export class setHasUnreadNotifications {
    static readonly type = `${ prefix } Set has unread notifications`;

    constructor(public hasUnreadNotifications: boolean) {
    }
  }
}
